import { noop } from "lodash";
import React from "react";

interface Props<P extends { handleClose: () => void }> {
  children: React.ReactElement;
  Modal: React.ComponentType<P>;
  modalProps?: Omit<P, "handleClose">;
  onOpenCallback?: (e: React.MouseEvent<HTMLElement>) => void;
  onCloseCallback?: () => void;
  disabled?: boolean;
}

const defaultModalProps = {};

function _ModalOpenButton<P extends { handleClose: () => void }>(
  {
    children,
    Modal,
    modalProps = defaultModalProps as P,
    onOpenCallback,
    onCloseCallback,
    disabled,
    ...props
  }: React.PropsWithChildren<Props<P>>,
  ref: React.ForwardedRef<HTMLElement>
) {
  const [isOpen, setIsOpen] = React.useState(false);

  const buttonWithOpen = React.cloneElement(children, {
    onClick:
      disabled ?? children.props.disabled
        ? noop
        : async (e: React.MouseEvent<HTMLElement>) => {
            await children.props.onClick?.(e);
            setIsOpen(true);
            onOpenCallback?.(e);
          },
    disabled: disabled ?? children.props.disabled,
    ...props,
    ref,
  });

  const buttonWithLoadingIndicator = React.cloneElement(children, {
    ...props,
    isLoading: true,
  });

  return (
    <React.Suspense fallback={buttonWithLoadingIndicator}>
      {buttonWithOpen}
      {isOpen && (
        // @ts-ignore
        <Modal
          {...modalProps}
          handleClose={() => {
            setIsOpen(false);
            onCloseCallback?.();
          }}
        />
      )}
    </React.Suspense>
  );
}

export const ModalOpenButton = React.forwardRef(_ModalOpenButton);
